import React from "react";
import EmptyBox from "./extras/EmptyBox";
import { ReactComponent as EmptyDocsSvg } from "../../assets/images/cm-empty-docs.svg";

const DocumentSection = () => {
  return (
    <div className="flex w-full h-full items-center justify-center">
      <span className="flex flex-col items-center">
        {/* <EmptyBox width={350} height={350} /> */}
        <EmptyDocsSvg />
        {/* <p className="text-2xl">Nothing to see here.</p> */}
      </span>
    </div>
  );
};

export default DocumentSection;
